/* Sound toggle for the film player.

   aria-pressed carries both the accessible state and the equaliser animation,
   so it is the only thing that changes. The prototype leaves the button's
   aria-label fixed at "Toggle sound" regardless of state; here the label swaps
   with it, so a screen reader announces what the button will do rather than
   what it is called. */
(function () {
  'use strict';

  const H = window.Hystride;
  if (!H) return;

  H.register('film-player', {
    mount(root) {
      const button = root.querySelector('[data-film-sound]');
      const video = root.querySelector('video');
      if (!button || !video) return null;

      const sync = () => {
        const on = !video.muted;
        button.setAttribute('aria-pressed', String(on));
        button.setAttribute('aria-label', on ? button.dataset.labelOn : button.dataset.labelOff);
      };

      const onClick = () => {
        video.muted = !video.muted;
        // Unmuting a video the browser autoplayed silently can require a fresh
        // play() call; it is a user gesture here, so it will be allowed.
        if (!video.muted) video.play().catch(() => {});
        sync();
      };

      button.addEventListener('click', onClick);
      video.addEventListener('volumechange', sync);
      sync();

      return { button, video, onClick, sync };
    },

    unmount(root, s) {
      if (!s) return;
      s.button.removeEventListener('click', s.onClick);
      s.video.removeEventListener('volumechange', s.sync);
    },
  });
})();
